<template>
  <message-page :title="title" :subtitle="subtitle" slots>
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-slot:prepend>
      <img :src='imgSrc' class='img' :alt="subtitle||title"/>
    </template> 
  </message-page>
</template>

<script>
import { defineComponent } from 'vue'
import MessagePage from './MessagePage'

export default defineComponent({
  components:{
    MessagePage
  },
  props: {
    title: {
      type: [String, Number],
    },
    subtitle: {
      type: String,
    },
    imgSrc: {
      type: String,
      required: true
    },
    imgAlt: {
      type: String,
    }
  }
})
</script>


<style lang="scss" scoped>
.img {
  width: clamp(200px, 50vw, 400px);
}
</style>